export default __webpack_public_path__ + "static/media/R13.26af0e15.JPG";